module.exports = __webpack_public_path__ + "assets/apple-touch-icon-76-prod-d07e03.png";